import { useIsMutating } from 'react-query';

import { updateAddOnsMutationKey } from './use-update-booking-add-ons-mutation.hook';

export const useIsUpdatingBookingAddOns = () =>
  Boolean(useIsMutating(updateAddOnsMutationKey));
